import { render, staticRenderFns } from "./LimitedPartnerDetails.vue?vue&type=template&id=0a431742&scoped=true"
import script from "./LimitedPartnerDetails.vue?vue&type=script&lang=js"
export * from "./LimitedPartnerDetails.vue?vue&type=script&lang=js"
import style0 from "./LimitedPartnerDetails.vue?vue&type=style&index=0&id=0a431742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a431742",
  null
  
)

export default component.exports